var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStreamlineAlarmClockSolid = function SvgStreamlineAlarmClockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.147 2.017A1.072 1.072 0 0 0 4.14.126 13.4 13.4 0 0 0 .26 3.23a1.071 1.071 0 1 0 1.623 1.397 11.3 11.3 0 0 1 3.264-2.61M10 20a8.57 8.57 0 1 0 0-17.14A8.57 8.57 0 0 0 10 20M14.411.569a1.07 1.07 0 0 1 1.45-.443A13.4 13.4 0 0 1 19.74 3.23a1.072 1.072 0 0 1-1.623 1.397 11.3 11.3 0 0 0-3.264-2.61A1.07 1.07 0 0 1 14.41.57m-3.518 6.574a.893.893 0 0 0-1.786 0v4.286c0 .492.4.892.893.892h3.571a.893.893 0 0 0 0-1.785h-2.678z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgStreamlineAlarmClockSolid;